
import Vue, { PropType } from 'vue'

import JImageNote from '@/ui/controls/JImageNote.vue'

import Image from '@/models/Image'

export default Vue.extend({
  components: {
    JImageNote,
  },
  props: {
    image: Object as PropType<Image>,
    hideClose: Boolean,

    flat: Boolean,
    dark: Boolean,
  },
  data: () => ({
    errors: [] as Array<string>,
  }),
  methods: {
    onError(v: string) {
      this.errors.push(v)
    },
    isError(url: string) {
      return this.errors.includes(url)
    },
    retryUrl(url: string) {
      const errorIndex = this.errors.indexOf(url)
      if (errorIndex >= 0) this.errors.splice(errorIndex, 1)
    },
  },
})
